import React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react';
import { Rate } from '../services/ApiService';
import { TripPurpose } from '../store/logbookStore';

interface PurposeSelectorProps {
    purpose: TripPurpose | null;
    rates: Rate[];
    onPurposeChange: (purpose: TripPurpose | null) => void;
    dropdownStyles?: Partial<IDropdownStyles>;
}

const PurposeSelector: React.FC<PurposeSelectorProps> = ({
    purpose,
    rates,
    onPurposeChange,
    dropdownStyles,
}) => {
    const purposeOptions: IDropdownOption[] = rates.map((r) => ({
        key: r.id,
        text: r.purpose,
    }));

    const handleChange = (_: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (!option) {
            onPurposeChange(null);
            return;
        }

        onPurposeChange(option.key as TripPurpose);
    };

    return (
        <Dropdown
            placeholder="Účel"
            label="Účel"
            required
            selectedKey={purpose}
            onChange={handleChange}
            options={purposeOptions}
            styles={dropdownStyles}
        />
    );
};

export default PurposeSelector;
